export default "__VITE_ASSET__LOXpkefj__"